import { c as _c } from "react/compiler-runtime";
import type { OnboardingRequirementCollectDocument } from '@onefootprint/request-types';
import PhotoCapture from '../../../components/photo-capture/photo-capture';
import { ID_OUTLINE_HEIGHT_RATIO, ID_OUTLINE_WIDTH_RATIO } from '../../../constants';
import type { CameraErrorCause, ReceivedImagePayload } from '../../../types';
type FrontPhotoCaptureViewProps = {
  docName: string;
  sideName: string;
  cameraTitle: string;
  previewTitle: string;
  previewSubtitle: string;
  requirement: OnboardingRequirementCollectDocument;
  hasBadConnectivity: boolean | undefined;
  allowPdf: boolean;
  onComplete: (payload: ReceivedImagePayload) => void;
  onBack: () => void;
  onCameraStuck: () => void;
  onCameraErrored: (cause: CameraErrorCause) => void;
  onCameraAccessDenied: () => void;
};
const FrontPhotoCaptureView = t0 => {
  const $ = _c(18);
  const {
    docName,
    sideName,
    cameraTitle,
    previewTitle,
    previewSubtitle,
    requirement,
    hasBadConnectivity,
    allowPdf,
    onComplete,
    onBack,
    onCameraStuck,
    onCameraErrored,
    onCameraAccessDenied
  } = t0;
  let t1;
  if ($[0] !== cameraTitle || $[1] !== previewTitle) {
    t1 = {
      camera: cameraTitle,
      preview: previewTitle
    };
    $[0] = cameraTitle;
    $[1] = previewTitle;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== previewSubtitle) {
    t2 = {
      preview: previewSubtitle
    };
    $[3] = previewSubtitle;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== allowPdf || $[6] !== docName || $[7] !== hasBadConnectivity || $[8] !== onBack || $[9] !== onCameraAccessDenied || $[10] !== onCameraErrored || $[11] !== onCameraStuck || $[12] !== onComplete || $[13] !== requirement || $[14] !== sideName || $[15] !== t1 || $[16] !== t2) {
    t3 = <PhotoCapture autocaptureKind="idDoc" cameraKind="back" deviceKind="mobile" allowPdf={allowPdf} sideName={sideName} docName={docName} requirement={requirement} hasBadConnectivity={hasBadConnectivity} outlineHeightRatio={ID_OUTLINE_HEIGHT_RATIO} outlineWidthRatio={ID_OUTLINE_WIDTH_RATIO} title={t1} subtitle={t2} onComplete={onComplete} onBack={onBack} onCameraStuck={onCameraStuck} onCameraErrored={onCameraErrored} onCameraAccessDenied={onCameraAccessDenied} />;
    $[5] = allowPdf;
    $[6] = docName;
    $[7] = hasBadConnectivity;
    $[8] = onBack;
    $[9] = onCameraAccessDenied;
    $[10] = onCameraErrored;
    $[11] = onCameraStuck;
    $[12] = onComplete;
    $[13] = requirement;
    $[14] = sideName;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
};
export default FrontPhotoCaptureView;